// /calendar/events/new — create page (W40.1 F7).
//
// A page, not a sheet. The month view's `+` used to open a `BottomSheet`
// docked over the grid it was editing, which is a 44px-tall target living inside
// a scroll container with a docked action bar — the same arrangement W35.6 had
// to fix for every other create page by hiding the pill nav. The calendar was
// the last module still on the old pattern.
//
// Route ordering matters more than it looks: `/calendar/events/new` is a
// **literal** path sitting above the `/calendar/events/:id` sibling. See the
// note in `App.tsx` — this project has now hit that twice.

import { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { EventForm } from "@/components/calendar/EventForm";

export function CalendarEventNewPage() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  // The long-press seed travels as `?date=`, so a long-press on the 14th lands
  // on the 14th rather than on today.
  const initialDate = params.get("date");
  // W58.1 — `?category=cycle` 是「一鍵補記」的入口：月曆上提示「經期比
  // 預期晚了」的時候，那顆按鈕要能直接開一個**已經是週期類型**的表單，
  // 而不是讓使用者自己去點一次「週期」。
  const initialCategory = params.get("category");

  const onDone = useCallback(
    ({ ids, dayCount, isEdit }: { ids: string[]; dayCount: number; isEdit: boolean }) => {
      // The ids ride along in the navigation state so the month view can open
      // its undo bar immediately: one 「復原」 has to remove every row a
      // scattered selection created, not the first one.
      //
      // **這裡不推成功 toast** —— 目的地（月曆頁）的**撤銷條**已經說了同一句話，
      // 並且多給一個「復原」動作。再說一次就是同一句話在同一個畫面上說兩遍
      // （ADR-0215）。修改那一側不一樣：它的目的地（事件詳情頁）沒有撤銷條，
      // 所以由 `CalendarEventEdit` 自己說。
      nav("/calendar", { state: { calendarUndo: { ids, dayCount, isEdit } } });
    },
    [nav],
  );

  return (
    <EventForm
      initialDate={initialDate}
      initialCategory={initialCategory}
      backTo="/calendar"
      onDone={onDone}
    />
  );
}
